var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pricing-plan"},[_c('div',{staticClass:"iq-icon"},[_vm._t("cardIcon")],2),_vm._v(" "),_vm._t("cardTitle"),_vm._v(" "),_vm._t("cardText"),_vm._v(" "),_vm._t("cardPrice"),_vm._v(" "),_vm._t("cardButton")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }